import { useState } from 'react';
import { useAuthContext } from 'hooks/useAuthContext';
import { MobileNavButton } from './MobileNavButton';
import { MobileNavDrawer } from './MobileNavDrawer';

export const MobileNav = () => {
  const { userState } = useAuthContext();
  const [open, setOpen] = useState(false);

  if (!userState.user.userId) {
    return null;
  }

  return (
    <>
      <MobileNavButton onClick={() => setOpen(true)} />
      <MobileNavDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};
